export const defaultDrawerWidth = 245;
export const testDrawerWidth = 240;
export const minDrawerWidth = 240;
export const maxDrawerWidth = 700;
export const headerHeight = 150;
export const reducedDrawerWidth = 200;
export const showItemManagement = "true";
